import type { BuyRequestView, BuyPayoutAccount } from "../../shared/buy";
import { jsonInit, request } from "../lib/api";
import { resizeImage } from "../lib/resizeImage";

const same: RequestInit = { credentials: "same-origin" };

export const buyApi = {
  mine: (signal?: AbortSignal) => request<BuyRequestView[]>("/api/me/buy-requests", { ...same, signal }),
  create: (b: Record<string, unknown>) => request<BuyRequestView>("/api/me/buy-requests", jsonInit("POST", b)),
  uploadPhoto: async (number: string, file: Blob) => {
    const form = new FormData();
    form.append("image", await resizeImage(file), "photo");
    return request<{ photos: string[] }>(`/api/me/buy-requests/${number}/photos`, { ...same, method: "POST", body: form });
  },
  act: (number: string, action: "send" | "accept" | "reject" | "cancel", account?: BuyPayoutAccount) =>
    request<BuyRequestView>(`/api/me/buy-requests/${number}/${action}`, jsonInit("POST", account ? { account } : {})),
};
